import axios from 'axios';
import { toast } from 'react-toastify';

// Set up axios interceptors for global error handling
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // Check if this is a network/connection error (expected when backend is unavailable)
    const isNetworkError = 
      !error.response && (
        error.code === 'ERR_NETWORK' ||
        error.code === 'ECONNREFUSED' ||
        error.code === 'ETIMEDOUT' ||
        error.code === 'ECONNABORTED' ||
        error.message === 'Network Error' ||
        (error.message && error.message.includes('ERR_CONNECTION_ABORTED')) ||
        (error.message && error.message.includes('ERR_SSL_PROTOCOL_ERROR')) ||
        (error.message && error.message.includes('timeout'))
      );
    
    // Only handle non-network errors (actual API errors)
    if (!isNetworkError) {
      // Handle 401 Unauthorized errors globally
      if (error.response?.status === 401) {
        const currentPath = window.location.pathname;
        
        // Don't redirect if already on a login page or on public pages (like /live/)
        // Public pages should handle 401 errors gracefully without redirecting
        const isPublicPage = currentPath.includes('/live/') || 
                           currentPath.includes('/register/') || 
                           currentPath.includes('/registered-players/') ||
                           currentPath.includes('/auction-results/');
        
        if (!currentPath.includes('/login') && !isPublicPage) {
          // Clear authentication data
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          
          // Determine which login page to redirect to based on the error or current path
          let loginPath = '/login/tournament-admin';
          if (currentPath.includes('/dashboard/superadmin') || currentPath.includes('/superadmin')) {
            loginPath = '/login/super-admin';
          }
          
          // Show error message
          toast.error('Session expired. Please login again.');
          
          // Redirect to login page
          setTimeout(() => {
            window.location.href = loginPath;
          }, 1000);
        }
      }
    }
    // For network errors, silently reject (components can handle gracefully)
    // For API errors, reject normally so components can handle them
    
    return Promise.reject(error);
  }
);

export default axios;

